import React from "react";
import Navbar from "../../components/navbar";
import { ServicesScreen } from "../index";
const Home = () => {
  return (
    <div className="flex">
      <Navbar />
      <ServicesScreen />
    </div>
  );
};

export default Home;
